import initState from './initState';

const generateType = (actionType = 'CUSTOM', reducer = 'UNIVERSAL/ACCOUNT') => `${reducer}/${actionType}`;

export const login = (info = {}) => {
	return async (dispatch, getState) => {
		const account = { ...info };

		localStorage.setItem('_account', JSON.stringify(account));
		if (info?.token) {
			localStorage.setItem('token', JSON.stringify(info.token));
			localStorage.setItem('token-expired-time', Date.now() + 1000 * 60 * 60 * 24);
		}

		await dispatch({
			type: generateType('CUSTOM'),
			payload: account,
		});
	};
};

export const logout = () => {
	localStorage.removeItem('_account');
	localStorage.removeItem('token');
	localStorage.removeItem('token-expired-time');

	return async (dispatch) => {
		await dispatch({
			type: generateType('CUSTOM'),
			payload: initState,
		});
	};
};

export const setAccount = () => {
	return async (dispatch, getState) => {
		const account = localStorage.getItem('_account');
		if (!account) return;

		await dispatch({
			type: generateType('CUSTOM'),
			payload: { ...JSON.parse(account) },
		});
	};
};
